/**
 * Enable custom file inputs.
 *
 * @param {object} [options={}] - Optional options.
 * @param {string} [options.multipleFilesLabel=':anz files selected'] - Label to add if multiple files are selected. Use <code>:anz</code> as placeholder for the selected numbers.
 * @param {string} [options.elementSelector='.input--file'] - DOM selector to target the file input elements.
 * @param {string} [options.inputSelector='[type="file"]'] - DOM selector to target the input element relative to <code>options.widgetSelector</code>.
 * @param {string} [options.fileIconSelector='.input--file__input__icon'] - DOM selector to target the file input's icon relative to <code>options.widgetSelector</code>. Required to correctly clear on clicks.
 */
export async function fileInput(options) {
    let elements = document.querySelectorAll(options.elementSelector || '.input--file');

    if (elements.length) {
        let { initFileInput } = await import(/* webpackMode: "lazy" */ './inc/file-input.async');

        initFileInput(elements, options);
    }
}
